/**
 * Removes a pair of surrounding angle brackets that email clients often add when an
 * address is copied (e.g. "<john@example.com>" -> "john@example.com") and trims
 * surrounding whitespace. Use before validating an email or sending it to the backend.
 */
export const sanitizeEmail = (email: string): string => {
  const trimmed = email.trim();
  if (trimmed.startsWith("<") && trimmed.endsWith(">")) {
    return trimmed.slice(1, -1).trim();
  }

  return trimmed;
};
